<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">审批</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>充值记录</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content">
      <div class="page-actions">
        <el-select v-model="coinType" placeholder="请选择coinType" clearable>
          <el-option v-for="item in coinList" :key="item" :label="item" :value="item"></el-option>
        </el-select>
        <el-select v-model="txStatus" placeholder="请选择txStatus" clearable>
          <el-option v-for="item in txStatusOption" :key="item.value" :label="item.lable"
            :value="item.value"></el-option>
        </el-select>
        <el-select v-model="txType" placeholder="请选择充值类型">
          <el-option v-for="item in txTypeOption" :key="item.value" :label="item.lable" :value="item.value"></el-option>
        </el-select>
        <!-- <el-select v-model="txDepositStatus" placeholder="请选择txDepositStatus">
          <el-option v-for="item in coinList" :key="item" :label="item" :value="item"></el-option>
        </el-select> -->
        <el-input placeholder="请输入userId" v-model="userId" clearable>
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-input placeholder="合伙人UID" v-model="channelUserId" clearable>
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-button type="primary" @click="showMock">模拟盘充值</el-button>
        <el-button type="primary" @click="showTestDeposit">测试充值</el-button>
        <el-input placeholder="请输入转入钱包地址" v-model="walletAddres" clearable>
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-date-picker v-model="value1" type="daterange" align="right" value-format="timestamp" unlink-panels
          :clearable="true" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
          @change="changeTime($event)" :picker-options="pickerOptions">
        </el-date-picker>
        <el-button type="primary" @click="handleSearch">搜索</el-button>
        <el-button @click="exportData">导出Excel</el-button>
        <!-- <span>待查询的Hash值为：{{hash}}</span> -->
      </div>
      <div class="pl_total_box">
        <div class="pl_total">
          <span>充值汇总</span>
          <span></span>
          <span>{{ totalInfo | fixD(6) }}</span>
          <!-- <span>USDT</span> -->
        </div>
        <!-- <div class="pl_total">
          <span>总计盈亏</span>
          <span></span>
          <span>{{ totalRealizedProfit | fixD(6) }}</span>
          <span>USDT</span>
        </div> -->
        <!-- <div class="pl_total">
          <span>持仓手续费汇总</span>
          <span></span>
          <span>{{ totalFee | fixD(6) }}</span>
          <span>USDT</span>
        </div> -->
      </div>
      <audit-list @refresh="handleSearch($event)"></audit-list>
    </el-card>
    <el-dialog :visible="showMockVisible" title="模拟盘充值" width="400px" @close="closeMockMOdel">
      <el-form label-width="100px">
        <el-form-item label="用户id:">
          <el-input v-model="mockData.userId" placeholder="请输入用户id"></el-input>
        </el-form-item>
        <el-form-item label="币种:">
          <el-select v-model="mockData.coinType" placeholder="请选择币种" filterable>
            <el-option v-for="item in coinList" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="数量:">
          <el-input-number v-model="mockData.amount" :min="0" :precision="8"></el-input-number>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="closeMockMOdel(false)">取消</el-button>
        <el-button type="primary" @click="submitMock">确认</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible="showTestDepositVisible" title="测试充值" width="400px" @close="closeTestDepositModel">
      <el-form label-width="100px">
        <el-form-item label="用户id:">
          <el-input v-model="testDepositData.userId" placeholder="请输入用户id" @blur="loadTestDepositChains"></el-input>
        </el-form-item>
        <el-form-item label="币种:">
          <el-select v-model="testDepositData.coinType" placeholder="请选择币种" filterable @change="handleTestDepositCoinChange">
            <el-option v-for="item in coinList" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="链路:">
          <el-select v-model="testDepositData.chain" placeholder="请选择链路" filterable :disabled="!testDepositData.coinType">
            <el-option v-for="item in testDepositChains" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="数量:">
          <el-input-number v-model="testDepositData.amount" :min="0" :precision="8"></el-input-number>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="closeTestDepositModel(false)">取消</el-button>
        <el-button type="primary" @click="submitTestDeposit">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import "./store";
import { mapState, mapActions } from "vuex";
import AuditList from "./components/list";
import api from "./api";
import moment from "moment";
import { transformTime } from "@/utils/formatTime";
export default {
  name: "loglim",
  data() {
    return {
      value1: "",
      channelUserId: "",
      coinType: "",
      userId: "",
      txStatus: "",
      txType: "",
      walletAddres: "",
      txStatusOption: [
        { lable: "已经确认", value: 0 },
        { lable: "已提交", value: 1 },
        { lable: "取消", value: 2 },
        { lable: "失败", value: -1 },
        { lable: "确认中", value: 3 },
        { lable: "已审核", value: 4 },
        { lable: "区块链网络已经发送， 等待确认中", value: 5 },
        { lable: "系统错误", value: 6 },
        { lable: "管理员退回", value: 7 },
        { lable: "余额变更异常", value: 9 },
      ],
      txTypeOption: [
        { lable: "充值", value: 1 },
        { lable: "内部转账", value: -2 },
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      showMockVisible: false,
      showTestDepositVisible: false,
      testDepositChains: [],
      mockData: {
        userId: "",
        coinType: "",
        amount: 0,
      },
      testDepositData: {
        userId: "",
        coinType: "",
        chain: "",
        amount: 0,
      },
    };
  },
  components: {
    AuditList,
  },
  computed: {
    ...mapState("depositeRecord", ["pagination", "coinList", "totalInfo"]),
    ...mapState("mining", ["coinTypeList"]),
  },
  methods: {
    ...mapActions("depositeRecord", [
      "gethashList",
      "getAllCoins",
      "getTotalInfo",
    ]),
    ...mapActions("mining", ["getCoinTypeList"]),
    changeTime(e) {
      this.gethashList({
        type: 1,
        coinType: this.coinType,
        userId: this.userId,
        channelUserId: this.channelUserId,
        txStatus: this.txStatus,
        txType: this.txType,
        walletAddres: this.walletAddres,
        ...transformTime({
          startTime: "startTime",
          endTime: "endTime",
          startTimeNUmber: this.value1 ? this.value1[0] : "",
          endTimeNUmber: this.value1 ? this.value1[1] : "",
        }),
        ...this.pagination,
        onlyChannel: this.onlyChannel == -1 ? this.onlyChannel : this.inputUid,
      });
      this.getTotalInfo({
        type: 1,
        coinType: this.coinType,
        userId: this.userId,
        channelUserId: this.channelUserId,
        txStatus: this.txStatus,
        txType: this.txType,
        walletAddres: this.walletAddres,
        ...transformTime({
          startTime: "startTime",
          endTime: "endTime",
          startTimeNUmber: this.value1 ? this.value1[0] : "",
          endTimeNUmber: this.value1 ? this.value1[1] : "",
        }),
        onlyChannel: this.onlyChannel == -1 ? this.onlyChannel : this.inputUid,
      });
    },
    showMock() {
      this.showMockVisible = true;
    },
    showTestDeposit() {
      this.showTestDepositVisible = true;
    },
    closeMockMOdel() {
      this.showMockVisible = false;
      this.mockData = {
        userId: "",
        coinType: "",
        amount: 0,
      };
    },
    closeTestDepositModel() {
      this.showTestDepositVisible = false;
      this.testDepositChains = [];
      this.testDepositData = {
        userId: "",
        coinType: "",
        chain: "",
        amount: 0,
      };
    },
    handleTestDepositCoinChange() {
      this.testDepositData.chain = "";
      this.loadTestDepositChains();
    },
    loadTestDepositChains() {
      if (!this.testDepositData.userId || !this.testDepositData.coinType) {
        this.testDepositChains = [];
        return;
      }
      api.getTestDepositChains({
        userId: this.testDepositData.userId,
        coinType: this.testDepositData.coinType,
      }).then((res) => {
        if (res.code == 0) {
          this.testDepositChains = res.data || [];
          if (!this.testDepositChains.includes(this.testDepositData.chain)) {
            this.testDepositData.chain = "";
          }
          if (this.testDepositChains.length === 1) {
            this.testDepositData.chain = this.testDepositChains[0];
          }
        }
      });
    },
    submitMock() {
      if (!this.mockData.userId) {
        return this.$message.error("请输入用户id！");
      }
      if (!this.mockData.coinType) {
        return this.$message.error("请选择币种！");
      }
      if (this.mockData.amount == "" || this.mockData.amount == null || this.mockData.amount <= 0) {
        return this.$message.error("请输入数量！");
      }
      api.mock_deposit(this.mockData).then((res) => {
        if (res.code == 0) {
          this.$message.success("操作成功！");
          this.closeMockMOdel();
          this.handleSearch();
        }
      });
    },
    submitTestDeposit() {
      if (!this.testDepositData.userId) {
        return this.$message.error("请输入用户id！");
      }
      if (!this.testDepositData.coinType) {
        return this.$message.error("请选择币种！");
      }
      if (!this.testDepositData.chain) {
        return this.$message.error("请选择链路！");
      }
      if (this.testDepositData.amount == "" || this.testDepositData.amount == null || this.testDepositData.amount <= 0) {
        return this.$message.error("请输入数量！");
      }
      api.test_deposit(this.testDepositData).then((res) => {
        if (res.code == 0) {
          this.$message.success("操作成功，等待定时任务入账！");
          this.closeTestDepositModel();
          this.handleSearch();
        }
      });
    },
    handleSearch() {
      // let coin = this.$route.query.coin;
      // let toAddress = this.$route.query.toAddress;
      // if (coin&&toAddress) {
      this.gethashList({
        channelUserId: this.channelUserId,
        coinType: this.coinType,
        userId: this.userId,
        txStatus: this.txStatus,
        walletAddres: this.walletAddres,
        type: 1,
        txType: this.txType,
        ...this.pagination,
        ...transformTime({
          startTime: "startTime",
          endTime: "endTime",
          startTimeNUmber: this.value1 ? this.value1[0] : "",
          endTimeNUmber: this.value1 ? this.value1[1] : "",
        }),
      });
      this.getTotalInfo({
        type: 1,
        coinType: this.coinType,
        txType: this.txType,
        ...transformTime({
          startTime: "startTime",
          endTime: "endTime",
          startTimeNUmber: this.value1 ? this.value1[0] : "",
          endTimeNUmber: this.value1 ? this.value1[1] : "",
        }),
        userId: this.userId,
        channelUserId: this.channelUserId,
        txStatus: this.txStatus,
        walletAddres: this.walletAddres,
      });
      // } else {
      //   this.$message.error("币种和地址不能为空");
      //   return;
      // }
    },

    exportData() {
      const data = {
        channelUserId: this.channelUserId,
        coinType: this.coinType,
        userId: this.userId,
        txStatus: this.txStatus,
        walletAddres: this.walletAddres,
        type: 1,
        txType: this.txType,
        ...this.pagination,
        ...transformTime({
          startTime: "startTime",
          endTime: "endTime",
          startTimeNUmber: this.value1 ? this.value1[0] : "",
          endTimeNUmber: this.value1 ? this.value1[1] : "",
        }),
      };
      api.getSearchDepositExport(data).then((res) => {
        const link = document.createElement("a");
        const blob = new Blob([res], { type: "application/vnd.ms-excel" }); //设置文件流
        link.style.display = "none";
        // 设置连接
        link.href = URL.createObjectURL(blob); //将文件流转化为blob地址

        link.download = "充值记录";
        document.body.appendChild(link);
        // 模拟点击事件
        link.click(); //设置点击事件
      });
    },
  },
  mounted() {
    this.handleSearch();
    this.getCoinTypeList();
    this.getAllCoins();
  },
};
</script>

<style lang="less" scoped>
.page-actions>.el-input {
  width: 400px;
}
</style>
